// src/pages/salesMenu.js

import "../styles/salesMenu.css";
import "../styles/loadingModal.css";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import useAuth from "../components/useAuth";
import FilterField from "../components/salesFilters";
import GenericModal from "../components/filtersModal";
import LoadingModal from "../components/loadingModal";

import homeIcon from "../assets/home-icon.png";

import * as XLSX from "xlsx";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  AreaChart,
  Area
} from "recharts";

export default function SalesMenu() {

  const { userName, clientName } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Galileo Analytics - Ventas";
  }, []);

  useEffect(() => {

    obtenerUltimaSincronizacion();

  }, []);

  // =========================================================
  // MODAL
  // =========================================================

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  const [ultimaSincronizacion, setUltimaSincronizacion] = useState(null);

  const obtenerUltimaSincronizacion = async () => {

    try {

      const response = await fetch(
        "api/lastSync.php",
        {
          method: "GET",
          credentials: "include"
        }
      );
      if (response.status === 401) {
        return;
      }
      // Primero obtenemos el texto crudo
      const text = await response.text();
      //console.log("Respuesta lastSync.php:", text);
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        // console.error(
        //   "Error parseando respuesta de lastSync.php:",
        //   text
        // );

        return;
      }
      if (data.success) {
        setUltimaSincronizacion(
          data.ultimaSincronizacion
        );
      } else {
        // console.error(
        //   "Error en lastSync.php:",
        //   data.message || data.error || "Error desconocido"
        // );

      }
    } catch (error) {

      console.error(
        "Error obteniendo última sincronización:",
        error
      );

    }
  };

  const openFilterModal = async (type) => {

    setModalData([]);
    setModalType(type);
    setModalTitle("Seleccionar " + type);
    setModalOpen(true);

    try {

      const response = await fetch(
        "api/salesFilters.php?filter=" + type,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text = await response.text();

      try {
        const data = JSON.parse(text);
        setModalData(data);
      } catch (jsonError) {
        console.error("JSON parse error:", text);
        setModalData([]);
      }

    } catch (error) {
      console.error("Error cargando datos:", error);
      setModalData([]);
    }
  };

  const openOrderModal = () => {

    setModalType("orderBy");
    setModalTitle("Ordenar Por:");

    setModalData([
      { label: "Más Reciente", value: "fechaDesc" },
      { label: "Más Antiguo", value: "fechaAsc" },
      { label: "Cliente", value: "clienteAsc" },
      { label: "Vendedor", value: "vendedorAsc" },
      { label: "Comprobante", value: "comprobanteAsc" }
    ]);

    setModalOpen(true);
  };

  const openPeriodModal = () => {

    setModalType("period");
    setModalTitle("Período:");

    setModalData([
      { label: "Hoy", value: "hoy" },
      { label: "Esta Semana", value: "semana" },
      { label: "Este Mes", value: "mes" }
    ]);

    setModalOpen(true);
  };

  const closeFilterModal = () => {
    setModalOpen(false);
    setModalType("");
    setModalTitle("");
  };

  // =========================================================
  // FILTROS
  // =========================================================

  const filters = [

    {
      label: "Período",
      type: "select",
      name: "period",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openPeriodModal()
    },

    { label: "Desde", type: "date", name: "fechaDesde" },
    { label: "Hasta", type: "date", name: "fechaHasta" },

    {
      label: "Cliente",
      type: "text",
      name: "cliente",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("cliente")
    },

    {
      label: "Sucursal",
      type: "text",
      name: "sucursal",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("sucursal"),
      placeholder: "Central por Defecto"
    },

    {
      label: "Vendedor",
      type: "text",
      name: "vendedor",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("vendedor")
    },

   /* {
      label: "Ruta",
      type: "text",
      name: "ruta",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("ruta")
    },*/

    {
      label: "Comprobante",
      type: "text",
      name: "comprobante",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("comprobante")
    }

 /*   {
      label: "Ordenar Por",
      type: "select",
      name: "orderBy",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openOrderModal()
    }*/
  ];

  const [filtersState, setFiltersState] = useState({

    fechaDesde: "",
    fechaHasta: "",

    cliente: "",
    cCliente: "",

    sucursal: "",
    cSucursal: "",

    vendedor: "",
    cVendedor: "",

    ruta: "",
    cRuta: "",

    comprobante: "",
    cComprobante: "",

    orderBy: "",
    orderValue: "",

    period: "Hoy",
    periodValue: "hoy"
  });

  // =========================================================
  // SELECCIÓN DE MODAL
  // =========================================================

  const handleSelect = (item) => {

    if (!modalType) return;

    const pick = (obj, ...keys) => {
      for (const k of keys) {
        if (obj == null) continue;
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          return obj[k];
        }
      }
      return undefined;
    };

    switch (modalType) {

      case "cliente": {

        const text = pick(item, "cliente", "CLIENTE", "nombre", "NOMBRE");
        const val = pick(item, "cCliente", "CCLIENTE", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          cliente: text ?? "",
          cCliente: val ?? ""
        }));

        break;
      }

      case "sucursal": {

        const text = pick(item, "sucursal", "SUCURSAL", "nombre", "NOMBRE");
        const val = pick(item, "cSucursal", "CSUCURSAL", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          sucursal: text ?? "",
          cSucursal: val ?? ""
        }));

        break;
      }

      case "vendedor": {

        const text = pick(item, "usuario", "USUARIO", "nombre", "NOMBRE");
        const val = pick(item, "cUsuario", "CUSUARIO", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          vendedor: text ?? "",
          cVendedor: val ?? ""
        }));

        break;
      }

      case "ruta": {

        const text = pick(item, "ruta", "RUTA", "nombre", "NOMBRE");
        const val = pick(item, "cRuta", "CRUTA", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          ruta: text ?? "",
          cRuta: val ?? ""
        }));

        break;
      }

      case "comprobante": {

        const text = pick(item, "comprobante", "COMPROBANTE", "nombre", "NOMBRE");
        const val = pick(item, "cComprobante", "CCOMPROBANTE", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          comprobante: text ?? "",
          cComprobante: val ?? ""
        }));

        break;
      }

      case "orderBy": {

        setFiltersState(prev => ({
          ...prev,
          orderBy: item.label,
          orderValue: item.value
        }));

        break;
      }

      case "period": {

        setFiltersState(prev => ({
          ...prev,
          period: item.label,
          periodValue: item.value,
          fechaDesde: "",
          fechaHasta: ""
        }));

        break;
      }

      default:
        break;
    }

    closeFilterModal();
  };

  // =========================================================
  // DATA
  // =========================================================

  const [salesData, setSalesData] = useState([]);

  const [totals, setTotals] = useState({
    totalIVA: 0,
    totalNetoIVA: 0,
    totalPercepIIBB: 0,
    totalImpInterno: 0,
    totalNoGravado: 0,
    totalFinal: 0
  });

  const [statsData, setStatsData] = useState([]);

  const [loading, setLoading] = useState(false);

  // =========================================================
  // LIMPIAR FILTROS
  // =========================================================

  const clearFilters = () => {

    setFiltersState({

      fechaDesde: "",
      fechaHasta: "",

      cliente: "",
      cCliente: "",

      sucursal: "",
      cSucursal: "",

      vendedor: "",
      cVendedor: "",

      ruta: "",
      cRuta: "",

      comprobante: "",
      cComprobante: "",

      orderBy: "",
      orderValue: "",

      period: "Hoy",
      periodValue: "hoy"
    });

    setSalesData([]);
    setStatsData([]);

    setTotals({
      totalIVA: 0,
      totalNetoIVA: 0,
      totalPercepIIBB: 0,
      totalImpInterno: 0,
      totalNoGravado: 0,
      totalFinal: 0
    });
  };

  // =========================================================
  // UTILIDADES
  // =========================================================

  const parseDateStrict = (rawDate) => {

    if (!rawDate) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(rawDate)) {

      const [y, m, d] = rawDate.split("-");
      return new Date(Number(y), Number(m) - 1, Number(d));
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(rawDate)) {

      const [d, m, y] = rawDate.split("/");
      return new Date(Number(y), Number(m) - 1, Number(d));
    }

    const f = new Date(rawDate);

    return isNaN(f) ? null : f;
  };

  const formatMoney = (value) => {

    return Number(value || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  const formatMonthLabel = (key) => {

    const [y, m] = key.split("-");

    const d = new Date(Number(y), Number(m) - 1, 1);

    return d.toLocaleString("es-AR", {
      month: "short",
      year: "numeric"
    });
  };

  // =========================================================
  // AGRUPACIÓN
  // =========================================================

  const buildMonthlyStats = (data) => {

    const map = {};

    data.forEach((item) => {

      const fecha = parseDateStrict(item.FECHA_COMPROBANTE);

      if (!fecha) return;

      const key =
        `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}`;

      if (!map[key]) {
        map[key] = {
          fecha: key,
          total: 0
        };
      }

      map[key].total += Number(item.TOTAL_FINAL || 0);
    });

    return Object.values(map).sort((a, b) =>
      a.fecha.localeCompare(b.fecha)
    );
  };

  // =========================================================
  // APLICAR FILTROS
  // =========================================================

  const handleApplyFilters = async (e) => {

    e.preventDefault();

    setLoading(true);

    setSalesData([]);
    setStatsData([]);

    const filtros = {

      fechaDesde: filtersState.fechaDesde || null,
      fechaHasta: filtersState.fechaHasta || null,

      cCliente: filtersState.cCliente || null,
      cSucursal: filtersState.cSucursal || null,
      cVendedor: filtersState.cVendedor || null,
     /* cRuta: filtersState.cRuta || null,*/
      cComprobante: filtersState.cComprobante || null,

      period: filtersState.periodValue || null
    };

    try {

      const response = await fetch(
        "api/salesList.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify(filtros)
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text = await response.text();

      let data = [];

      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Error parseando JSON:", e);
        setLoading(false);
        return;
      }

      let ordered = [...data];

     /* switch (filtersState.orderValue) {

        case "fechaAsc":
          ordered.sort((a, b) =>
            new Date(a.FECHA_COMPROBANTE) - new Date(b.FECHA_COMPROBANTE)
          );
          break;

        case "fechaDesc":
          ordered.sort((a, b) =>
            new Date(b.FECHA_COMPROBANTE) - new Date(a.FECHA_COMPROBANTE)
          );
          break;

        case "clienteAsc":
          ordered.sort((a, b) =>
            a.CLIENTE.localeCompare(b.CLIENTE)
          );
          break;

        case "vendedorAsc":
          ordered.sort((a, b) =>
            a.USUARIO.localeCompare(b.USUARIO)
          );
          break;

        default:
          break;
      }*/

      setSalesData(ordered);

      const sum = (field) =>
        ordered.reduce(
          (acc, item) => acc + (parseFloat(item[field]) || 0),
          0
        );

      setTotals({

        totalIVA: sum("TOTAL_IVA"),

        totalNetoIVA: sum("TOTAL_NETO"),

        totalPercepIIBB: sum("TOTAL_PERCEP_IIBB"),

        totalImpInterno: sum("TOTAL_IMPUESTOINTERNO"),

        totalNoGravado: sum("TOTAL_NOGRAVADO"),

        totalDevoluciones: sum("TOTAL_DEVOLUCIONES"),

        totalFinal:
          sum("VENTAS_BRUTAS") - sum("TOTAL_DEVOLUCIONES")
      });

      setStatsData(buildMonthlyStats(ordered));

      setLoading(false);

    } catch (error) {

      console.error("Error al obtener ventas:", error);

      setLoading(false);
    }
  };

  // =========================================================
  // EXPORTAR EXCEL
  // =========================================================

  const exportToExcel = () => {

    if (!salesData || salesData.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const headers = [
      "Sucursal",
      "Comprobante",
      "PV - N° Comp.",
      "Cliente",
      "Fecha",
      "Total",
      "Total Pagos",
      "Vendedor",
      "Divisa"
    ];

    const rows = salesData.map(row => [

      String(row.CSUCURSAL).padStart(3, "0"),

      `${row.SIGLA}-${row.LETRA}`,

      `${row.CPUNTO_VTA}-${row.NRO_CV}`,

      row.CLIENTE,

      row.FECHA_COMPROBANTE,

      Number(row.TOTAL_FINAL),

      Number(row.TOTAL_PAGOS),

      row.USUARIO,

      row.SIMBOLO_MONEDA
    ]);

    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.aoa_to_sheet([
      headers,
      ...rows
    ]);

    XLSX.utils.book_append_sheet(wb, ws, "Ventas");

    XLSX.writeFile(
      wb,
      "Galileo-Analytics-Ventas.xlsx"
    );
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      <div className="sales-menu">

        {/* ================================================= */}
        {/* FILTROS */}
        {/* ================================================= */}

        <aside className="filters-section">

          <div className="filters-header">

            <button
              type="button"
              className="home-button"
              onClick={() => navigate("/menu")}
            >
              <img src={homeIcon} alt="Home" />
            </button>

          </div>

          <h2>Filtros</h2>

          <form
            className="sales-filters-form"
            onSubmit={handleApplyFilters}
          >

            <div className="filters-body">

              {filters.map((f) => {

                let hiddenVal = "";

                if (f.name === "cliente") {
                  hiddenVal = filtersState.cCliente || "";
                }
                else if (f.name === "sucursal") {
                  hiddenVal = filtersState.cSucursal || "";
                }
                else if (f.name === "vendedor") {
                  hiddenVal = filtersState.cVendedor || "";
                }
                else if (f.name === "ruta") {
                  hiddenVal = filtersState.cRuta || "";
                }
                else if (f.name === "comprobante") {
                  hiddenVal = filtersState.cComprobante || "";
                }

                return (
                  <FilterField
                    key={f.name}
                    {...f}
                    value={filtersState[f.name] || ""}
                    hiddenValue={hiddenVal}
                    onChange={(e) => {

                      const value = e.target.value;

                      setFiltersState(prev => ({
                        ...prev,
                        [f.name]: value,

                        ...(f.name === "fechaDesde" || f.name === "fechaHasta"
                          ? { period: "", periodValue: "" }
                          : {})
                      }));
                    }}
                  />
                );
              })}

            </div>

            <button
              type="submit"
              className="filter-button"
            >
              Aplicar Filtros
            </button>

            <button
              type="button"
              className="delete-filter-button"
              onClick={clearFilters}
            >
              Borrar Filtros
            </button>

            <button
              type="button"
              className="export-excel-button"
              onClick={exportToExcel}
            >
              Exportar Datos
            </button>

          <div className="sync-info">
            <span>
              Última sincronización:{" "}
              {ultimaSincronizacion || "Sin datos"}
            </span>
          </div>

          </form>

        </aside>

        {/* ================================================= */}
        {/* DASHBOARD */}
        {/* ================================================= */}

        <main className="sales-data">

          {/* CARDS */}

          <div className="stats-cards">

            <div className="stat-card">
              <span>Total Neto</span>
              <h2>${formatMoney(totals.totalFinal)}</h2>
            </div>

            <div className="stat-card">
              <span>Total IVA</span>
              <h2>${formatMoney(totals.totalIVA)}</h2>
            </div>

            <div className="stat-card">
              <span>Neto Gravado</span>
              <h2>${formatMoney(totals.totalNetoIVA)}</h2>
            </div>

            <div className="stat-card">
              <span>No Gravado</span>
              <h2>${formatMoney(totals.totalNoGravado)}</h2>
            </div>

          </div>

          {/* CHARTS */}

          <div className="charts-grid">

            {/* BARRAS */}

            <div className="chart-card">

              <div className="chart-title">
                Ventas por Mes
              </div>

              <div className="chart-wrapper">

                <ResponsiveContainer width="100%" height="100%">

                  <BarChart
                    data={statsData}
                    margin={{
                      top: 20,
                      right: 20,
                      left: 0,
                      bottom: 10
                    }}
                  >

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                      dataKey="fecha"
                      tickFormatter={formatMonthLabel}
                    />

                    {/* <YAxis
                      tickFormatter={formatMoney}
                    /> */}
                    <YAxis
                      tickFormatter={formatMoney}
                      width={110}
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 11
                      }}
                    />

                    <Tooltip
                      formatter={(value) =>
                        `$${formatMoney(value)}`
                      }
                      labelFormatter={formatMonthLabel}
                    />

                    <Bar
                      dataKey="total"
                      fill="#0077b6"
                      radius={[8, 8, 0, 0]}
                    />

                  </BarChart>

                </ResponsiveContainer>

              </div>

            </div>

            {/* AREA */}

            <div className="chart-card">

              <div className="chart-title">
                Evolución de Ventas
              </div>

              <div className="chart-wrapper">

                <ResponsiveContainer width="100%" height="100%">

                  <AreaChart
                    data={statsData}
                    margin={{
                      top: 20,
                      right: 20,
                      left: 0,
                      bottom: 10
                    }}
                  >

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                      dataKey="fecha"
                      tickFormatter={formatMonthLabel}
                    />

                    <YAxis
                      tickFormatter={formatMoney}
                      width={110}
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 11
                      }}
                    />

                    <Tooltip
                      formatter={(value) =>
                        `$${formatMoney(value)}`
                      }
                      labelFormatter={formatMonthLabel}
                    />

                    <Area
                      type="monotone"
                      dataKey="total"
                      stroke="#0077b6"
                      fill="#90e0ef"
                    />

                  </AreaChart>

                </ResponsiveContainer>

              </div>

            </div>

          </div>

          {/* RESUMEN */}

          <div className="summary-card">

            <h3>Resumen General</h3>

            <div className="summary-grid">

              <div>
                <span>IVA</span>
                <strong>${formatMoney(totals.totalIVA)}</strong>
              </div>

              <div>
                <span>Neto IVA</span>
                <strong>${formatMoney(totals.totalNetoIVA)}</strong>
              </div>

              <div>
                <span>Percepción IIBB</span>
                <strong>${formatMoney(totals.totalPercepIIBB)}</strong>
              </div>

              <div>
                <span>Imp. Internos</span>
                <strong>${formatMoney(totals.totalImpInterno)}</strong>
              </div>

              <div>
                <span>No Gravado</span>
                <strong>${formatMoney(totals.totalNoGravado)}</strong>
              </div>

              <div>
                <span>Total Devoluciones</span>
                <strong>${formatMoney(totals.totalDevoluciones)}</strong>
              </div>

              <div>
                <span>Total Final</span>
                <strong>${formatMoney(totals.totalFinal)}</strong>
              </div>

            </div>

          </div>

        </main>

      </div>

      {/* FOOTER */}

      <div className="sales-menu-footer">

      <div className="footer-left-logo">

        <img
          className="footer-system-logo"
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />

      </div>

        <footer>
          <span>
            Sesión Actual: {userName} | {clientName}
          </span>
        </footer>

      </div>

      {/* MODAL */}

      <GenericModal
        title={modalTitle}
        isOpen={modalOpen}
        data={modalData}
        onSelect={handleSelect}
        onClose={closeFilterModal}
      />

      <LoadingModal open={loading} />

    </>
  );
}